import { render, staticRenderFns } from "./positionList.vue?vue&type=template&id=1d270bbb&scoped=true&"
import script from "./positionList.vue?vue&type=script&lang=js&"
export * from "./positionList.vue?vue&type=script&lang=js&"
import style0 from "./positionList.vue?vue&type=style&index=0&id=1d270bbb&scoped=true&lang=css&"
import style1 from "./positionList.css?vue&type=style&index=1&id=1d270bbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d270bbb",
  null
  
)

export default component.exports